import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-education',
  imports: [PillarPagesTemp],
  templateUrl: './education.html',
  styleUrl: './education.scss',
})
export class Education {

}
